// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC<{ width?: number; height?: number }> = ({ width = 30, height = 21 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 21">
            <path
                fill="currentColor"
                d="M29.3956044,3.28125 C29.0659341,1.96875 28.021978,0.984375 26.7032967,0.65625 C24.3956044,0 15,0 15,0 C15,0 5.6043956,0 3.2967033,0.65625 C1.97802198,0.984375 0.989010989,1.96875 0.604395604,3.28125 C0,5.6328125 0,10.5 0,10.5 C0,10.5 0,15.421875 0.604395604,17.7734375 C0.989010989,19.03125 1.97802198,20.015625 3.2967033,20.3984375 C5.6043956,21 15,21 15,21 C15,21 24.3956044,21 26.7582418,20.3984375 C28.021978,20.015625 29.0659341,19.03125 29.3956044,17.7734375 C30,15.421875 30,10.5 30,10.5 C30,10.5 30,5.6328125 29.3956044,3.28125 Z M11.9230769,14.984375 L11.9230769,6.0703125 L19.7802198,10.5 L11.9230769,14.984375 Z"
            />
        </svg>
    );
};

export default React.memo(Youtube);
